import { SystemModel } from '../system/system.model';
import { FileModel } from '../file/file.model';

/**
 * Project status enum based on Swagger specification
 */
export enum ProjectStatus {
    Inactive = 0,
    Active = 1,
    Archived = 2,
    Deleted = 3
}

/**
 * Project model based on Swagger specification
 */
export interface ProjectModel {
    Id?: string;
    Name: string;
    Description?: string;
    Directory?: string;
    DirectoryName?: string;
    FilePath?: string;
    System?: SystemModel;
    ProjectFile?: FileModel;
    Status?: ProjectStatus;
    CreatedAtUtc?: Date;
    LastModifiedAtUtc?: Date;
    CreatedAt?: Date;
    UpdatedAt?: Date;
}



